import React, { useState, useEffect } from "react";
import Link from "next/link";
import { Icon } from "components/SvgIcons";
import Tabs from "../Tabs";
import { MetaWrap } from "shared/Meta/styled";
import { LinkWrap, SocialNetworks } from "styles/SocialNetworks.styled";
import { colors } from "styles/colors";
import Button from "shared/Button";
import { NoImage } from "styles/App.styled";
import { useSelector } from "react-redux";
import { RecipesContext } from "./fragment/RecipesContext";
import { CollectionsContext } from "./fragment/CollectionsContext";
import { pagesName } from "variables/recipesVariables";
import Products from "./Products";
import { useIsMounted } from "helpers/hooks/useIsMounted";

import {
  ProfileInfo,
  Title,
  TabsType1,
  ProfileDesc,
  CreatorNameWrapper,
  TitleUser,
  UserLocation,
  MobileHr,
  DesktopHr,
  CreatorName,
} from "./styled";
import { RecipesPagesSearch } from "../RecipesPagesSearch/RecipesPagesSearch";
import { DraftsTab } from "./fragment/DraftsTab/DraftsTab";
import { isUserBuyer } from "store/userReducer/userSelectors";
import MyInfoImg from "shared/MyInfoImg";
import { isPreviewDraft } from "store/recipesReducer/recipesSelectors";

import { useRenderDevice } from "helpers/hooks/useRenderDevice";

const Creator = ({ isOwner, user, page, active, setActive }) => {
  const preview = useSelector(isPreviewDraft);
  const isBuyer = useSelector(isUserBuyer);
  const isDesktop = useRenderDevice({ min: 769 });
  const isMounted = useIsMounted();

  const [tabsNav, setTadsNav] = useState([
    {
      id: 1,
      icon: "collection",
      text: "Collections",
    },
    {
      id: 2,
      icon: "recipes_2",
      text: "Recipes",
    },
  ]);
  const [tabsContent, setTadsContent] = useState([
    {
      id: 1,
      content: <CollectionsContext page={page} />,
    },
    {
      id: 2,
      content: <RecipesContext page={page} />,
    },
  ]);

  useEffect(() => {
    if (page === "recipe_manager" && tabsNav.every((item) => item.text !== "My Drafts")) {
      const tabDraft = {
        id: 3,
        icon: "draft",
        text: "Drafts",
      };
      const draftContent = {
        id: 3,
        content: <DraftsTab />,
      };

      if (isBuyer) {
        setTadsNav([...tabsNav.filter((tab) => tab.id !== 1), tabDraft]);
        setTadsContent([...tabsContent.filter((tab) => tab.id !== 1), draftContent]);
        setActive(2);
      } else {
        setTadsNav([...tabsNav, tabDraft]);
        setTadsContent([...tabsContent, draftContent]);
      }
    }
  }, [page]);

  const socLinks = [
    { name: "Website", icon: "website_2", color: colors.PINK, url: user.website_link && `${user.website_link}` },
    { name: "Facebook", icon: "fb_2", color: colors.BLUE_100, url: user.facebook_url && `${user.facebook_url}` },
    { name: "Twitter", icon: "twitter_2", color: colors.BLUE_200, url: user.twitter_url && `${user.twitter_url}` },
    { name: "Instagram", icon: "instagram_2", color: colors.PINK, url: user.instagram_url && `${user.instagram_url}` },
    { name: "TikTok", icon: "tiktok_2", color: colors.PINK, url: user.tiktok_url && `${user.tiktok_url}` },
    { name: "YouTube", icon: "youtube_2", color: colors.PINK, url: user.youtube_url && `${user.youtube_url}` },
  ];

  const renderName = () => (
    <TitleUser>{user.show_business_name ? user.business_name : `${user.first_name} ${user.last_name}`}</TitleUser>
  );

  return (
    <>
      {page === "recipe_manager" || page === "library" ? (
        !preview && (
          <Title className="profile">
            {page === "library" && "Library"}
            {page === "recipe_manager" && !preview && "Recipe Manager"}
          </Title>
        )
      ) : (
        <>
          <ProfileInfo>
            {!user.main_image ? <NoImage className="buyer" /> : <MyInfoImg image={user.main_image} />}
            <CreatorNameWrapper>
              <CreatorName>
                <div>
                  {renderName()}
                  {user.work_place && (
                    <MetaWrap>
                      <UserLocation work_place={user.work_place}>
                        <a>{user.work_place ? user.work_place : ""}</a>
                      </UserLocation>
                      <UserLocation>
                        <a>{user.location ? user.location : ""}</a>
                      </UserLocation>
                    </MetaWrap>
                  )}
                </div>
                <SocialNetworks className="user">
                  {socLinks
                    .filter((item) => item.url)
                    .map((item, i) => (
                      <LinkWrap
                        key={i}
                        className="user"
                        href={item.url}
                        target="_blank"
                        aria-label={item.name}
                        rel="nofollow, noopener, noreferrer"
                      >
                        <Icon extraClass="user" icon={item.icon} />
                      </LinkWrap>
                    ))}
                </SocialNetworks>
              </CreatorName>
              <DesktopHr />
              {isDesktop && isMounted && (
                <ProfileDesc>
                  <p>{user.bio ? user.bio : ""}</p>
                  {isOwner && (
                    <Link href={`/settings`}>
                      <Button
                        bdButton={colors.WHITE}
                        iconRight="edit"
                        color={colors.RED}
                        textColor={colors.WHITE}
                        text="Edit my profile"
                        stylType="secondary"
                      />
                    </Link>
                  )}
                </ProfileDesc>
              )}
            </CreatorNameWrapper>
          </ProfileInfo>
          <MobileHr />
          {!isDesktop && isMounted && (
            <ProfileDesc>
              <p>{user.bio ? user.bio : ""}</p>

              {isOwner && (
                <Link href={`/settings`}>
                  <Button
                    bdButton={colors.WHITE}
                    iconRight="edit"
                    color={colors.RED}
                    textColor={colors.WHITE}
                    text="Edit my profile"
                    stylType="secondary"
                  />
                </Link>
              )}
            </ProfileDesc>
          )}
        </>
      )}
      {page === pagesName.manager && <RecipesPagesSearch pageName={page} />}
      {(page === "recipe_manager" || page === "library") && (
        <TabsType1>
          <Tabs
            list={!preview && tabsNav}
            setTab={setActive}
            tabContent={tabsContent}
            active={active}
            canChangeTab={true}
          />
        </TabsType1>
      )}
      {page === "users" && <Products />}
    </>
  );
};

export default Creator;
